/* eslint react/destructuring-assignment: 0 */

import React, { useMemo } from 'react'
import { matchPath, Route, useLocation, match } from 'react-router-dom'
import { Location } from 'history'
import { connect } from 'redaction'
import checkIfSEOPage from 'common/helpers/getters/isSEOPage'
import router from './router'


type MatchWithSeo = match & {
  isSEOPage?: boolean
  pageURL?: string
}

type LayoutSwitchProps = {
  reduxLocation?: Location
}

const LayoutSwitch: React.FunctionComponent<LayoutSwitchProps> = ({ children, reduxLocation }) => {
  const routeLocation = useLocation()

  const location = reduxLocation || routeLocation

  const [
    match,
    nodes,
  ] = useMemo(() => {
    let match = null
    let nodesToRender = []
    let nodes = null

    const matchRoute = (child) => {
      const { path, from, exact, strict, sensitive } = child.props

      const match = matchPath(location.pathname, { path: path || from, exact, strict, sensitive }) as MatchWithSeo

      // if it's not found page
      if (match && match.path === '*') {
        match.isSEOPage = checkIfSEOPage(location.pathname)
        match.pageURL = location.pathname
      }

      return match
    }

    /*

    match /zoo

    <Route path="/foo" />
    <Redirect from="/bar0" to="/bar1" />

    <InsideLayout>
      <Route path="/bar1" />
      <Route path="/bar2" />
    </InsideLayout>

    <HasAuth>
      <InsideLayout>
        <Route path="/zoo" />
      </InsideLayout>
    </HasAuth>

   */
    const matchRoutes = (children) => {
      React.Children.forEach(children, (child: React.ReactElement<{ children?: React.ReactNode }>) => {
        if (!match && React.isValidElement(child)) {
          if (child.props.children) {
            // if node is Layout then add it to nodesToRender
            nodesToRender.push(child)
            // and iterate again
            matchRoutes(child.props.children)

            // if in nested routes no match then remove added Layout (move up by tree)
            if (!match) {
              nodesToRender.pop()
            }
          }
          else {
            match = matchRoute(child)

            // if pathname match route path then add Route to nodesToRender
            if (match) {
              nodesToRender.push(child)
            }
          }
        }
      })
    }

    matchRoutes(children)

    // try to render nodes
    if (match) {
      // TODO move this to separate container
      router.dispatch(match)

      nodes = nodesToRender.reverse().reduce((result, node) => {
        // render route
        if (!result) {
          // TODO try to replace Route with Component, ask @pivanov
          // return React.createElement(node.props.component, { location })
          return React.cloneElement(node, { location, computedMatch: match })
        }

        // render layout
        return React.cloneElement(node, { location }, result)
      }, null)
    }

    return [
      match,
      // return reversed routes
      nodes,
    ]
  }, [ location, children ])

  if (!match) {
    return null
  }

  // @ts-ignore
  return React.createElement(Route, { location, computedMatch: match }, nodes)
}


export default connect({
  reduxLocation: 'routing.location',
})(LayoutSwitch)
